import {
    forwardRef,
    useImperativeHandle,
    useRef,
    useState,
} from "react"

import MonthYearElement from "../MonthYearElement"
import OptionInput from "../OptionInput"

const options = [
    {
        title: "Select",
        key: "",
    },
    {
        title: "Yes",
        key: "yes",
    },
    {
        title: "No",
        key: "no",
    },
]

const EducationCompleteAndDateInput = forwardRef(({ title, data, readOnly }, ref) => {

    const fieldData = data || {
        isEducationComplete: options[0].key,
    }

    const [optionIsEducationComplete, setOptionIsEducationComplete] = useState(fieldData.isEducationComplete)

    const optionRef = useRef()
    const dateOfDegreeRef = useRef()

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {

            const optionResult = optionRef.current.validateAndGetData()
            const dateOfDegreeResult = dateOfDegreeRef.current?.validateAndGetData()

            return {
                isValid: optionResult.isValid && (dateOfDegreeResult?.isValid ?? true),
                value: {
                    isEducationComplete: optionResult.value,
                    dateOfDegree: dateOfDegreeResult?.value,
                },
            }
        },
    }))



    return (
        <div className="my-4">

            <OptionInput
                ref={optionRef}
                data={fieldData.isEducationComplete}
                options={options}
                title={"Did you complete your Education?"}
                valueChangeHandler={setOptionIsEducationComplete}
                readOnly={readOnly}
            />
            {
                optionIsEducationComplete === "yes" && (
                    <MonthYearElement
                        title={"Date when Qualification/Degree was received?"}
                        ref={dateOfDegreeRef}
                        data={fieldData.dateOfDegree}
                        readOnly={readOnly}
                        maxFutureYearsFromNow={0}
                    />
                )
            }
        </div>
    )
})

export default EducationCompleteAndDateInput
